import React from 'react';
import PropTypes from 'prop-types';
import decodeHtmlEntities from 'unescape';
import Styles from './Note.scss';

const Note = ({ value }) => (
  <div
    className={Styles.note}
    dangerouslySetInnerHTML={{ __html: decodeHtmlEntities(value) }}
  />
);

Note.propTypes = {
  value: PropTypes.string
};

export default Note;
